export default __webpack_public_path__ + "static/media/erasmusDisco.660432d0.mp4";